import { Notification } from '@agilelab/plugin-wb-notification-common';
import { IconButton, IconButtonProps } from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import DraftsIcon from '@material-ui/icons/Drafts';
import { useCallback } from 'react';
import { useNotification } from './useNotificationProvider';

export const MarkAsReadButton = (
  props: IconButtonProps & { notification: Notification },
) => {
  const { notification, ...iconButtonProps } = props;
  const { readStatus, setRead } = useNotification();

  const handleClick = useCallback(
    (e: any) => {
      e.stopPropagation();
      setRead(notification.id.toString());
    },
    [notification.id, setRead],
  );

  if (readStatus !== 'read' && !notification.read_at)
    return (
      <WbTooltip title="Mark as read">
        <IconButton
          aria-label="mark as read"
          onClick={e => handleClick(e)}
          {...iconButtonProps}
        >
          <DraftsIcon fontSize="small" />
        </IconButton>
      </WbTooltip>
    );

  return null;
};
